import { useHistory } from 'react-router-dom';
import LangEnum from '../../../lang/LangEnum';
import { ClarityEvents } from '../../../lib/clarity/types/clarityEvents.types';
import { captureEvent } from '../../../lib/clarity/utils/captureEvent.utils';
import snackbarStore from '../../../stores/Snackbar.store';
import { useApplicationContext } from '../../context/ApplicationContext/ApplicationContext';
import { Brand } from '../../context/ApplicationContext/applicationContext.types';
import useAppEnvironment from '../../context/ApplicationContext/hooks/useAppEnvironment/useAppEnvironment';
import useEnterBrand from '../../context/ApplicationContext/hooks/useEnterBrand/useEnterBrand';
import { Paths } from '../../my-network/myNetwork.types';
import { getMyNetworkTabPath } from '../../my-network/myNetworkUtils';
import { useTranslation } from '../../translation/TranslationContext';

type UseBrandSelectModalParams = {
  onClose: () => void;
  onClick?: (brand: Brand) => void;
};

const useBrandSelectModal = ({ onClose, onClick }: UseBrandSelectModalParams) => {
  const { translate } = useTranslation();
  const history = useHistory();
  const { handleMessage } = snackbarStore;
  const { applyEnvironment, applyStoreEnvironment } = useAppEnvironment();
  const { team, removeSelectedBrand } = useApplicationContext();
  const { enterBrand } = useEnterBrand();

  const searchBrandsUrl = getMyNetworkTabPath(Paths.EXPLORE);

  const handleClick = (brand: Brand) => {
    if (onClick) {
      applyEnvironment(team?.role, brand.id);
      onClick(brand);
      return;
    }

    enterBrand(brand);
    onClose();
  };

  const handleClickGoToLink = (link: string) => {
    history.push(link);
    onClose();
  };

  const handleGoToStore = () => {
    captureEvent(ClarityEvents.CLICKED_BACK_TO_STORE);
    removeSelectedBrand();
    applyStoreEnvironment();
    history.push('/');
    handleMessage({ type: 'info', message: translate(LangEnum.BRAND_STORE_ENVIRONMENT_MESSAGE) });
    onClose();
  };

  return {
    searchBrandsUrl,
    handleClick,
    handleClickGoToLink,
    handleGoToStore,
  };
};

export default useBrandSelectModal;
